var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/svg-macros.j2"] = require( "macros/svg-macros.j2" );
dependencies["macros/smallscreen-swatch-truncation.j2"] = require( "macros/smallscreen-swatch-truncation.j2" );
dependencies["core-product-swatch.j2"] = require( "core-product-swatch.j2" );
dependencies["core-product-swatch-multi.j2"] = require( "core-product-swatch-multi.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/product-swatches.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/product-swatches.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("productUrl")) {
var t_4 = t_1.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_4);
env.getTemplate("macros/svg-macros.j2", false, "core/templates/macros/product-swatches.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("linkedSvg")) {
var t_8 = t_5.linkedSvg;
} else {
cb(new Error("cannot import 'linkedSvg'")); return;
}
context.setVariable("linkedSvg", t_8);
var macro_t_9 = runtime.makeMacro(
["colorCode", "productSlug", "sliceItems"], 
[], 
function (l_colorCode, l_productSlug, l_sliceItems, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("colorCode", l_colorCode);
frame.set("productSlug", l_productSlug);
frame.set("sliceItems", l_sliceItems);
var t_10 = "";t_10 += "\n    <ul class=\"o-list-swatches u-clearfix\" data-qa-available-swatches>";
frame = frame.push();
var t_13 = l_sliceItems;
if(t_13) {var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("sliceItem", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
t_10 += runtime.suppressValue((lineno = 18, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "displaySwatch"), "displaySwatch", context, [t_14,l_colorCode,l_productSlug,"product"])), env.opts.autoescape);
;
}
}
frame = frame.pop();
t_10 += "</ul>\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_10);
});
context.addExport("displayPdpSwatches");
context.setVariable("displayPdpSwatches", macro_t_9);
var macro_t_15 = runtime.makeMacro(
["products"], 
["truncateSwatches", "numberOfSwatchesToDisplay", "source", "enabled"], 
function (l_products, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("products", l_products);
frame.set("truncateSwatches", kwargs.hasOwnProperty("truncateSwatches") ? kwargs["truncateSwatches"] : false);
frame.set("numberOfSwatchesToDisplay", kwargs.hasOwnProperty("numberOfSwatchesToDisplay") ? kwargs["numberOfSwatchesToDisplay"] : 0);
frame.set("source", kwargs.hasOwnProperty("source") ? kwargs["source"] : "category");
frame.set("enabled", kwargs.hasOwnProperty("enabled") ? kwargs["enabled"] : runtime.contextOrFrameLookup(context, frame, "True"));
var t_16 = "";t_16 += "\n\n    <ul class=\"o-list-swatches u-clearfix\" data-qa-available-swatches>";
var t_17;
t_17 = runtime.memberLookup((runtime.memberLookup((l_products),"product")),"productSlug");
frame.set("productSlug", t_17, true);
if(frame.topLevel) {
context.setVariable("productSlug", t_17);
}
if(frame.topLevel) {
context.addExport("productSlug", t_17);
}
var t_18;
t_18 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_products),"skuInfo")),"primarySlice")),"sliceItems");
frame.set("sliceItems", t_18, true);
if(frame.topLevel) {
context.setVariable("sliceItems", t_18);
}
if(frame.topLevel) {
context.addExport("sliceItems", t_18);
}
var t_19;
t_19 = env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "sliceItems")),0),{"code": "","images": runtime.contextOrFrameLookup(context, frame, "defaultImageIds")});
frame.set("firstSliceItem", t_19, true);
if(frame.topLevel) {
context.setVariable("firstSliceItem", t_19);
}
if(frame.topLevel) {
context.addExport("firstSliceItem", t_19);
}
var t_20;
t_20 = env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "firstSliceItem")),"images"),runtime.contextOrFrameLookup(context, frame, "defaultImageIds"));
frame.set("sliceImageIds", t_20, true);
if(frame.topLevel) {
context.setVariable("sliceImageIds", t_20);
}
if(frame.topLevel) {
context.addExport("sliceImageIds", t_20);
}
if(runtime.memberLookup((l_products),"productControls")) {
var t_21;
t_21 = env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((l_products),"productControls")),"colorCode"),"");
frame.set("colorCode", t_21, true);
if(frame.topLevel) {
context.setVariable("colorCode", t_21);
}
if(frame.topLevel) {
context.addExport("colorCode", t_21);
}
var t_22;
t_22 = "";
frame.set("viewCode", t_22, true);
if(frame.topLevel) {
context.setVariable("viewCode", t_22);
}
if(frame.topLevel) {
context.addExport("viewCode", t_22);
}
var t_23;
t_23 = "";
frame.set("hoverViewCode", t_23, true);
if(frame.topLevel) {
context.setVariable("hoverViewCode", t_23);
}
if(frame.topLevel) {
context.addExport("hoverViewCode", t_23);
}
;
}
else {
if((lineno = 51, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [l_products,"colors.0.faceOutImage"])) && env.getFilter("length").call(context, (lineno = 51, colno = 106, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_products),"colors")),0)),"faceOutImage")),"split"), "products[\"colors\"][\"0\"][\"faceOutImage\"][\"split\"]", context, ["_"]))) > 2) {
var t_24;
t_24 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 52, colno = 70, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_products),"colors")),0)),"faceOutImage")),"split"), "products[\"colors\"][\"0\"][\"faceOutImage\"][\"split\"]", context, ["_"]))),1),"");
frame.set("colorCode", t_24, true);
if(frame.topLevel) {
context.setVariable("colorCode", t_24);
}
if(frame.topLevel) {
context.addExport("colorCode", t_24);
}
var t_25;
t_25 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 53, colno = 69, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_products),"colors")),0)),"faceOutImage")),"split"), "products[\"colors\"][\"0\"][\"faceOutImage\"][\"split\"]", context, ["_"]))),2),"");
frame.set("viewCode", t_25, true);
if(frame.topLevel) {
context.setVariable("viewCode", t_25);
}
if(frame.topLevel) {
context.addExport("viewCode", t_25);
}
;
}
else {
if(runtime.memberLookup((l_products),"faceOutImage") && env.getFilter("length").call(context, (lineno = 54, colno = 71, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((l_products),"faceOutImage")),"split"), "products[\"faceOutImage\"][\"split\"]", context, ["_"]))) > 2) {
var t_26;
t_26 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 55, colno = 60, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((l_products),"faceOutImage")),"split"), "products[\"faceOutImage\"][\"split\"]", context, ["_"]))),1),"");
frame.set("colorCode", t_26, true);
if(frame.topLevel) {
context.setVariable("colorCode", t_26);
}
if(frame.topLevel) {
context.addExport("colorCode", t_26);
}
var t_27;
t_27 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 56, colno = 59, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((l_products),"faceOutImage")),"split"), "products[\"faceOutImage\"][\"split\"]", context, ["_"]))),2),"");
frame.set("viewCode", t_27, true);
if(frame.topLevel) {
context.setVariable("viewCode", t_27);
}
if(frame.topLevel) {
context.addExport("viewCode", t_27);
}
;
}
else {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "firstSliceItem")),"code")) {
t_16 += "\n                ";
var t_28;
t_28 = env.getFilter("default").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "firstSliceItem")),"code"),"");
frame.set("colorCode", t_28, true);
if(frame.topLevel) {
context.setVariable("colorCode", t_28);
}
if(frame.topLevel) {
context.addExport("colorCode", t_28);
}
t_16 += "\n                ";
var t_29;
t_29 = (lineno = 60, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "firstSliceItem"),"images[0]",""]));
frame.set("viewCode", t_29, true);
if(frame.topLevel) {
context.setVariable("viewCode", t_29);
}
if(frame.topLevel) {
context.addExport("viewCode", t_29);
}
;
}
else {
var t_30;
t_30 = "";
frame.set("colorCode", t_30, true);
if(frame.topLevel) {
context.setVariable("colorCode", t_30);
}
if(frame.topLevel) {
context.addExport("colorCode", t_30);
}
var t_31;
t_31 = "";
frame.set("viewCode", t_31, true);
if(frame.topLevel) {
context.setVariable("viewCode", t_31);
}
if(frame.topLevel) {
context.addExport("viewCode", t_31);
}
;
}
;
}
;
}
if((lineno = 65, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [l_products,"colors.0.hoverImage"])) && env.getFilter("length").call(context, (lineno = 65, colno = 102, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_products),"colors")),0)),"hoverImage")),"split"), "products[\"colors\"][\"0\"][\"hoverImage\"][\"split\"]", context, ["_"]))) > 2) {
var t_32;
t_32 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 66, colno = 72, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_products),"colors")),0)),"hoverImage")),"split"), "products[\"colors\"][\"0\"][\"hoverImage\"][\"split\"]", context, ["_"]))),2),runtime.contextOrFrameLookup(context, frame, "viewCode"));
frame.set("hoverViewCode", t_32, true);
if(frame.topLevel) {
context.setVariable("hoverViewCode", t_32);
}
if(frame.topLevel) {
context.addExport("hoverViewCode", t_32);
}
;
}
else {
if(runtime.memberLookup((l_products),"hoverImage") && env.getFilter("length").call(context, (lineno = 67, colno = 67, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((l_products),"hoverImage")),"split"), "products[\"hoverImage\"][\"split\"]", context, ["_"]))) > 2) {
var t_33;
t_33 = env.getFilter("default").call(context, runtime.memberLookup(((lineno = 68, colno = 62, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((l_products),"hoverImage")),"split"), "products[\"hoverImage\"][\"split\"]", context, ["_"]))),2),runtime.contextOrFrameLookup(context, frame, "viewCode"));
frame.set("hoverViewCode", t_33, true);
if(frame.topLevel) {
context.setVariable("hoverViewCode", t_33);
}
if(frame.topLevel) {
context.addExport("hoverViewCode", t_33);
}
;
}
else {
var t_34;
t_34 = runtime.contextOrFrameLookup(context, frame, "viewCode");
frame.set("hoverViewCode", t_34, true);
if(frame.topLevel) {
context.setVariable("hoverViewCode", t_34);
}
if(frame.topLevel) {
context.addExport("hoverViewCode", t_34);
}
;
}
;
}
;
}
if(runtime.contextOrFrameLookup(context, frame, "enabled")) {
frame = frame.push();
var t_37 = runtime.contextOrFrameLookup(context, frame, "sliceItems");
if(t_37) {var t_36 = t_37.length;
for(var t_35=0; t_35 < t_37.length; t_35++) {
var t_38 = t_37[t_35];
frame.set("sliceItem", t_38);
frame.set("loop.index", t_35 + 1);
frame.set("loop.index0", t_35);
frame.set("loop.revindex", t_36 - t_35);
frame.set("loop.revindex0", t_36 - t_35 - 1);
frame.set("loop.first", t_35 === 0);
frame.set("loop.last", t_35 === t_36 - 1);
frame.set("loop.length", t_36);
if(runtime.contextOrFrameLookup(context, frame, "tile") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"defaultViewCode")) {
var t_39;
t_39 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tile")),"defaultViewCode");
frame.set("viewCode", t_39, true);
if(frame.topLevel) {
context.setVariable("viewCode", t_39);
}
if(frame.topLevel) {
context.addExport("viewCode", t_39);
}
;
}
if(runtime.contextOrFrameLookup(context, frame, "truncateSwatches")) {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") <= runtime.contextOrFrameLookup(context, frame, "numberOfSwatchesToDisplay")) {
t_16 += runtime.suppressValue((lineno = 85, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "displaySwatch"), "displaySwatch", context, [t_38,runtime.contextOrFrameLookup(context, frame, "colorCode"),runtime.contextOrFrameLookup(context, frame, "productSlug"),runtime.contextOrFrameLookup(context, frame, "source"),runtime.makeKeywordArgs({"viewCode": runtime.contextOrFrameLookup(context, frame, "viewCode"),"hoverViewCode": runtime.contextOrFrameLookup(context, frame, "hoverViewCode")})])), env.opts.autoescape);
;
}
;
}
else {
t_16 += "<!--\n                        UW-5167 Don't remove this comment.\n                        Adding this helps mDom maintain its state\n                        on the first client render, preventing\n                        inaccurate hover states sticking around.\n                    -->\n                    ";
t_16 += runtime.suppressValue((lineno = 96, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "displaySwatch"), "displaySwatch", context, [t_38,runtime.contextOrFrameLookup(context, frame, "colorCode"),runtime.contextOrFrameLookup(context, frame, "productSlug"),runtime.contextOrFrameLookup(context, frame, "source"),runtime.makeKeywordArgs({"viewCode": runtime.contextOrFrameLookup(context, frame, "viewCode"),"hoverViewCode": runtime.contextOrFrameLookup(context, frame, "hoverViewCode")})])), env.opts.autoescape);
;
}
;
}
}
frame = frame.pop();
if(runtime.contextOrFrameLookup(context, frame, "truncateSwatches") && ((env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "sliceItems"))) > runtime.contextOrFrameLookup(context, frame, "numberOfSwatchesToDisplay"))) {
t_16 += "<li class=\"o-list-swatches__li--more\">\n                    <a class=\"o-list-swatches__more\" href=\"";
t_16 += runtime.suppressValue((lineno = 105, colno = 70, runtime.callWrap(t_4, "productUrl", context, [runtime.contextOrFrameLookup(context, frame, "productSlug")])), env.opts.autoescape);
t_16 += "\" title=\"";
t_16 += runtime.suppressValue((lineno = 105, colno = 95, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_tile-swatch-title",runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_products),"skuInfo")),"primarySlice")),"displayLabel")]})])), env.opts.autoescape);
t_16 += "\">+ ";
t_16 += runtime.suppressValue(env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_products),"skuInfo")),"primarySlice")),"sliceItems")) - runtime.contextOrFrameLookup(context, frame, "numberOfSwatchesToDisplay"), env.opts.autoescape);
t_16 += "</a>\n                </li>";
;
}
;
}
t_16 += "\n\n    </ul>\n\n    ";
env.getTemplate("macros/smallscreen-swatch-truncation.j2", false, "core/templates/macros/product-swatches.j2", null, function(t_42,t_40) {
if(t_42) { cb(t_42); return; }
t_40.render(context.getVariables(), frame, function(t_43,t_41) {
if(t_43) { cb(t_43); return; }
t_16 += t_41
})});
frame = frame.pop();
return new runtime.SafeString(t_16);
});
context.addExport("displaySwatches");
context.setVariable("displaySwatches", macro_t_15);
output += "\n\n";
var macro_t_44 = runtime.makeMacro(
["color", "colorCode", "productSlug", "source"], 
["viewCode", "hoverViewCode"], 
function (l_color, l_colorCode, l_productSlug, l_source, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("color", l_color);
frame.set("colorCode", l_colorCode);
frame.set("productSlug", l_productSlug);
frame.set("source", l_source);
frame.set("viewCode", kwargs.hasOwnProperty("viewCode") ? kwargs["viewCode"] : "");
frame.set("hoverViewCode", kwargs.hasOwnProperty("hoverViewCode") ? kwargs["hoverViewCode"] : "");
var t_45 = "";t_45 += "\n<li class=\"o-list-swatches__li\" data-qa-swatch-li ";
if(!runtime.contextOrFrameLookup(context, frame, "enabled")) {
t_45 += " disabled ";
;
}
t_45 += ">";
var t_46;
t_46 = (l_color && runtime.memberLookup((l_color),"images")?runtime.memberLookup((l_color),"images"):[]);
frame.set("images", t_46, true);
if(frame.topLevel) {
context.setVariable("images", t_46);
}
if(frame.topLevel) {
context.addExport("images", t_46);
}
var t_47;
t_47 = (runtime.inOperator(runtime.contextOrFrameLookup(context, frame, "viewCode"),runtime.contextOrFrameLookup(context, frame, "images"))?runtime.contextOrFrameLookup(context, frame, "True"):runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("viewCodeIsValid", t_47, true);
if(frame.topLevel) {
context.setVariable("viewCodeIsValid", t_47);
}
if(frame.topLevel) {
context.addExport("viewCodeIsValid", t_47);
}
if(runtime.memberLookup((l_color),"code") == l_colorCode) {
var t_48;
t_48 = " o-list-swatches__a--selected";
frame.set("selectedClass", t_48, true);
if(frame.topLevel) {
context.setVariable("selectedClass", t_48);
}
if(frame.topLevel) {
context.addExport("selectedClass", t_48);
}
;
}
else {
if(!l_colorCode || !runtime.contextOrFrameLookup(context, frame, "viewCodeIsValid")) {
var t_49;
t_49 = (runtime.contextOrFrameLookup(context, frame, "images") && env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "images"))?runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "images")),0):"");
frame.set("viewCode", t_49, true);
if(frame.topLevel) {
context.setVariable("viewCode", t_49);
}
if(frame.topLevel) {
context.addExport("viewCode", t_49);
}
var t_50;
t_50 = (runtime.contextOrFrameLookup(context, frame, "images") && env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "images")) > 1?runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "images")),1):runtime.contextOrFrameLookup(context, frame, "viewCode"));
frame.set("hoverViewCode", t_50, true);
if(frame.topLevel) {
context.setVariable("hoverViewCode", t_50);
}
if(frame.topLevel) {
context.addExport("hoverViewCode", t_50);
}
;
}
;
}
if(env.getFilter("lower").call(context, runtime.contextOrFrameLookup(context, frame, "colorwayName")) != "multi") {
t_45 += "\n        ";
env.getTemplate("core-product-swatch.j2", false, "core/templates/macros/product-swatches.j2", null, function(t_53,t_51) {
if(t_53) { cb(t_53); return; }
t_51.render(context.getVariables(), frame, function(t_54,t_52) {
if(t_54) { cb(t_54); return; }
t_45 += t_52
})});
}
else {
t_45 += "\n        ";
env.getTemplate("core-product-swatch-multi.j2", false, "core/templates/macros/product-swatches.j2", null, function(t_57,t_55) {
if(t_57) { cb(t_57); return; }
t_55.render(context.getVariables(), frame, function(t_58,t_56) {
if(t_58) { cb(t_58); return; }
t_45 += t_56
})});
}
t_45 += "</li>\n";
;
frame = frame.pop();
return new runtime.SafeString(t_45);
});
context.addExport("displaySwatch");
context.setVariable("displaySwatch", macro_t_44);
output += "\n\n\n";
var macro_t_59 = runtime.makeMacro(
["productTile"], 
[], 
function (l_productTile, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("productTile", l_productTile);
var t_60 = "";if(env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_productTile),"skuInfo")),"primarySlice")),"sliceItems")) > 1) {
t_60 += "<span class=\"u-clearfix\">\n\n            <a class=\"o-list-swatches__more\" href=\"";
t_60 += runtime.suppressValue((lineno = 148, colno = 62, runtime.callWrap(t_4, "productUrl", context, [runtime.memberLookup((runtime.memberLookup((l_productTile),"product")),"productSlug")])), env.opts.autoescape);
t_60 += "\" title=\"";
t_60 += runtime.suppressValue((lineno = 148, colno = 107, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_tile-swatch-title",runtime.makeKeywordArgs({"params": [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_productTile),"skuInfo")),"primarySlice")),"displayLabel")]})])), env.opts.autoescape);
t_60 += "\" data-qa-num-colors-available>\n\n                ";
t_60 += runtime.suppressValue(env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_productTile),"skuInfo")),"primarySlice")),"sliceItems")), env.opts.autoescape);
t_60 += " ";
t_60 += runtime.suppressValue((lineno = 150, colno = 71, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_tile-swatches-available"])), env.opts.autoescape);
t_60 += "\n\n            </a>\n\n        </span>";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_60);
});
context.addExport("displayNumColors");
context.setVariable("displayNumColors", macro_t_59);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/product-swatches.j2"] , dependencies)